module.exports = __webpack_public_path__ + "img/scissors-01.7441c598.svg";